import { css } from 'aphrodite';
import { baseStyleSheet, bs } from '../../../styles/styles';
import { styleSheet } from './styles';

interface Props {
	title: string;
	description: string;
	onTemplateCardClick: () => void;
	cardContextMenu?: React.ReactNode;
}

export const BlogPostTemplateCard = ({ title, description, onTemplateCardClick, cardContextMenu }: Props) => {
	return (
		<article
			className={css(
				bs.flex,
				bs.flexCol,
				bs.py8,
				bs.px6,
				bs.shadow,
				bs.itemsStart,
				bs.roundedLg,
				bs.relative,
				styleSheet.card
			)}
		>
			{cardContextMenu}
			<h3>{title}</h3>
			<p className={css(bs.flexGrow)}>
				{description.length > 100 ? `${description.substring(0, 100)}...` : description}
			</p>
			<button className={css(baseStyleSheet.ctaButtonReverseSmall, styleSheet.button)} onClick={onTemplateCardClick}>
				View Blog
			</button>
		</article>
	);
};
